import * as React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";

type ActiveClassNavLinkProps = Omit<NavLinkProps, "className"> & {
  className?: string;
  activeClassName?: string;
};

/**
 * A <NavLink> that adds `activeClassName` while its route is active, as React Router 6 betas did. Material UI
 * components pass a plain string className to the component they render, so the class function NavLink now expects
 * has to be built here.
 */
const ActiveClassNavLink = React.forwardRef<HTMLAnchorElement, ActiveClassNavLinkProps>(
  ({ className, activeClassName = "active", ...props }, ref) => (
    <NavLink
      ref={ref}
      {...props}
      className={({ isActive }) => [className, isActive ? activeClassName : null].filter(Boolean).join(" ")}
    />
  ),
);

export default ActiveClassNavLink;
